import { Link } from 'react-router-dom';

import styles from './Certifications.module.css';
import rightChevron from './../../assets/icons/RightChevron.svg';

// Images
import MSSpecialistLogo_1x from './../../assets/HomePage/TechnologyCertifications/1MSSpecialistLogo/MSSpecialistLogo_1x.webp';
import MSSpecialistLogo_2x from './../../assets/HomePage/TechnologyCertifications/1MSSpecialistLogo/MSSpecialistLogo_2x.webp';
import MSSpecialistLogo_M1x from './../../assets/HomePage/TechnologyCertifications/0Mobile/1MSSpecialistLogo/MSSpecialistLogo_1x.webp';
import MSSpecialistLogo_M2x from './../../assets/HomePage/TechnologyCertifications/0Mobile/1MSSpecialistLogo/MSSpecialistLogo_2x.webp';

import MSLogoMCSDLogo_1x from './../../assets/HomePage/TechnologyCertifications/2MSLogoMCSDLogo/MSLogoMCSDLogo_1x.webp';
import MSLogoMCSDLogo_2x from './../../assets/HomePage/TechnologyCertifications/2MSLogoMCSDLogo/MSLogoMCSDLogo_2x.webp';
import MSLogoMCSDLogo_M1x from './../../assets/HomePage/TechnologyCertifications/0Mobile/2MSLogoMCSDLogo/MSLogoMCSDLogo_1x.webp';
import MSLogoMCSDLogo_M2x from './../../assets/HomePage/TechnologyCertifications/0Mobile/2MSLogoMCSDLogo/MSLogoMCSDLogo_2x.webp';

import MSLogoCertifiedLogo_1x from './../../assets/HomePage/TechnologyCertifications/3MSLogoCertifiedLogo/MSLogoCertifiedLogo_1x.webp';
import MSLogoCertifiedLogo_2x from './../../assets/HomePage/TechnologyCertifications/3MSLogoCertifiedLogo/MSLogoCertifiedLogo_2x.webp';
import MSLogoCertifiedLogo_M1x from './../../assets/HomePage/TechnologyCertifications/0Mobile/3MSLogoCertifiedLogo/MSLogoCertifiedLogo_1x.webp';
import MSLogoCertifiedLogo_M2x from './../../assets/HomePage/TechnologyCertifications/0Mobile/3MSLogoCertifiedLogo/MSLogoCertifiedLogo_2x.webp';


export default function CertificationsComponent() {

    return (
        <Link to="/certifications" className={styles.certifications + ' section'}>
            <div className={styles.cardHeader}>
                <h2 className='D_HeadingSection'>Technology Certifications</h2>
                <span className='D_ViewAll'>VIEW ALL <img src={rightChevron} alt="Right Chevron" /></span>
            </div>
            <div className={styles.grid3 + ' section_content'}>
                <picture>
                    <source type="image/webp" media="(min-width:750px)" srcSet={MSSpecialistLogo_1x + ' 1x, ' + MSSpecialistLogo_2x + ' 2x'} alt="MS Specialist Logo" />
                    <source type="image/webp" media="(min-width:300px)" srcSet={MSSpecialistLogo_M1x + ' 1x, ' + MSSpecialistLogo_M2x + ' 2x'} alt="MS Specialist Logo" />
                    <img src={MSSpecialistLogo_1x} alt="MS Specialist Logo" />
                </picture>
                <picture>
                    <source type="image/webp" media="(min-width:750px)" srcSet={MSLogoMCSDLogo_1x + ' 1x, ' + MSLogoMCSDLogo_2x + ' 2x'} alt="MS MCSD Logo" />
                    <source type="image/webp" media="(min-width:300px)" srcSet={MSLogoMCSDLogo_M1x + ' 1x, ' + MSLogoMCSDLogo_M2x + ' 2x'} alt="MS MCSD Logo" />
                    <img src={MSLogoMCSDLogo_1x} alt="MS MCSD Logo" />
                </picture>
                <picture>
                    <source type="image/webp" media="(min-width:750px)" srcSet={MSLogoCertifiedLogo_1x + ' 1x, ' + MSLogoCertifiedLogo_2x + ' 2x'} alt="MS Certified Logo" />
                    <source type="image/webp" media="(min-width:300px)" srcSet={MSLogoCertifiedLogo_M1x + ' 1x, ' + MSLogoCertifiedLogo_M2x + ' 2x'} alt="MS Certified Logo" />
                    <img src={MSLogoCertifiedLogo_1x} alt="MS Certified Logo" />
                </picture>
            </div>
        </Link>
    );
}